import { createAction, createReducer } from 'redux-act';
import { API_INSTANCE_NO_CREDENTIALS } from '../../utils/service-http';
import { front_base_url } from '../../constants';

/**
 * Reducer and action used to retrieve the survey
 */

const surveyCache = {};

const DEFAULT_SURVEY_RETRIEVE_STATE = { surveyData: null, isLoading: false, error: null };

export const getSurveyStarted = createAction('GET_SURVEY_STARTED');
export const getSurveySuccess = createAction('GET_SURVEY_SUCCESS');
export const getSurveyFailed = createAction('GET_SURVEY_FAILED');

export const getSurveyReducer = createReducer(function (on, off) {
  on(getSurveyStarted, (state, payload) => {
    return {
      surveyData: null,
      isLoading: true,
      error: null,
    }
  });
  on(getSurveySuccess, (state, payload) => {
    return {
      surveyData: payload,
      isLoading: false,
      error: null,
    }
  });
  on(getSurveyFailed, (state, payload) => {
    return {
      surveyData: null,
      isLoading: false,
      error: null,
    }
  });
}, DEFAULT_SURVEY_RETRIEVE_STATE);

export const getSurvey = (surveyFileName) => {
  return async dispatch => {

    const cachedSurvey = surveyCache[surveyFileName];
    if (cachedSurvey) {
      dispatch(getSurveySuccess(cachedSurvey));
      return cachedSurvey;
    }

    dispatch(getSurveyStarted());

    return API_INSTANCE_NO_CREDENTIALS.get(`${front_base_url}/surveys/${surveyFileName}`)
      .then((success) => {
        dispatch(getSurveySuccess(success.data));
        surveyCache[surveyFileName] = success.data;
        return success.data;
      }).catch((error) => {
        dispatch(getSurveyFailed(error.message));
        throw error;
      })
  }
}






